<template>

    <div class="backoffice--sticky no-print">
        <b-container fluid>
            <ul class="navigation">
                <!--<li>
                    <router-link :to="{ name: 'homepage' }">homepage</router-link>
                </li>-->
                <li>
                  <router-link :to="{ name: 'requests' }">richieste</router-link>
                </li>
                <li>
                  <router-link :to="{ name: 'soldquotes' }">prenotazioni</router-link>
                </li>
                <li>
                  <router-link :to="{ name: 'structures' }">strutture</router-link>
                </li>
                <li>
                  <!-- questo pulsante duplica sempre una "richiesta di sistema" con id 1, vedi bobe migrations requests -->
                  <b-button @click="self_duplicate_request(1)" title="crea una richiesta fittizia per caricare un nuovo prodotto">crea nuovo</b-button>
                </li>
                <li>
                  <b-button title="crea una struttura"  v-b-modal="'newStructture'">inserisci struttura</b-button>
                </li>
                <b-modal :id="'newStructture'" :title="'Nuova struttura'" size="xl" hide-footer>
                <structures 
                    @closeModalStructures="(value) => closeModalStructures({
                        id: 'newStructture'
                    })"
                />
                </b-modal>
            </ul>
        </b-container>
    </div>    
</template>

<script>
    import {duplicate_request, get_me} from "@/api";
    import Structures from '@/components/blocks/structures'

    export default {
        name: 'backoffice-header',
        components: {
          'structures': Structures,
        },
        props: {
        },
        computed: {
        },
        data() {
            return {
                me: get_me(),
            }
        },
        methods:
        {
          closeModalStructures(param)
          {
            this.$bvModal.hide(param.id)
          },
          self_duplicate_request(request_id)
          {
            duplicate_request({ request_id: request_id})
                .then(response => {
                  (response)

                  this.$router.push({
                    name: 'new-quote',
                    params: {
                      request_id: response.new_request_id
                    }
                  })

                })
          }

        },
    }
</script>

<style lang="scss">
    .user-info
    {
        font-size: 12px;
    }
    .navigation
    {
        margin:0;
        padding:0;
        list-style:none;
        display: flex;
        align-items: center;
        justify-content: center;
        li
        {
            margin-right:1rem;
        }
        a
        {
            display: block;
            color:$white;
            background:$secondary;
            padding:10px 20px;
            transition:$transition-base;
            text-transform: uppercase;
            font-size: 16px;
            &:hover
            {
                color:$white;
                background:$info;
                text-decoration: none;
            }
        }
    }
</style>